export interface LocationHashParseResult {
  url: URL;
  hashPath: string;
  hashParams: Record<string, string>;
}

export const parseLocationHash = (locationHref = window.location.href): LocationHashParseResult => {
  const url = new URL(locationHref);
  const hashSplitted = url.hash.substring(1).split('?');
  const hashPath = hashSplitted[0];
  let hashParams: Record<string, string> = {};
  if (hashSplitted.length > 1) {
    hashParams = hashSplitted[1].split('&').reduce((res: Record<string, string>, item) => {
      const parts = item.split('=');
      res[parts[0]] = parts[1];
      return res;
    }, {});
  }
  return { url, hashPath, hashParams };
};
